<template>
  <section class="story01">
    <div class="story01--con">
      <div class="story01--subtit">
        <div class="subtit-bold">Brand</div><div class="subtit-light">Story</div>
      </div>
      <div class="story01--visual"></div>  
    </div>
  </section>
</template>

<script>
import Section from './Section1.vue'
export default {
  components: { Section },
  name: 'Section1',
}
</script>